import { DatePicker } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { formats } from '../../library/constants';
import dayjs from '../../library/utilities/dayjs.js';

export const defaultDateRangePresets = [
    { label: 'Today', value: [dayjs(), dayjs()] },
    { label: 'Yesterday', value: [dayjs().subtract(1, 'day'), dayjs().subtract(1, 'day')] },
    { label: 'This Week', value: [dayjs().startOf('week'), dayjs().endOf('week')] },
    {
        label: 'Last Week',
        value: [dayjs().subtract(1, 'week').startOf('week'), dayjs().subtract(1, 'week').endOf('week')],
    },
    { label: 'This Month', value: [dayjs().startOf('month'), dayjs().endOf('month')] },
    {
        label: 'Last Month',
        value: [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')],
    },
    { label: 'This Year', value: [dayjs().startOf('year'), dayjs().endOf('year')] },
    {
        label: 'Last Year',
        value: [dayjs().subtract(1, 'year').startOf('year'), dayjs().subtract(1, 'year').endOf('year')],
    },
]

const DateRangePicker = ({ value, onChange, presets = defaultDateRangePresets, ...otherProps }) => {
    const hasValue = Boolean(value?.[0] || value?.[1])
    const formattedDate = hasValue
        ? [
            value?.[0] ? dayjs(value[0], formats.backendDateFormat) : null,
            value?.[1] ? dayjs(value[1], formats.backendDateFormat) : null,
        ]
        : null

    return (
        <DatePicker.RangePicker
            value={formattedDate}
            presets={presets}
            onChange={(dates) => {
                if (!dates) {
                    onChange?.(null)
                    return
                }
                const [start_date, end_date] = dates
                // Wait until both ends are chosen so controlled re-renders do not reset mid-selection
                if (!start_date || !end_date) {
                    return
                }
                onChange?.([
                    start_date.format(formats.backendDateFormat),
                    end_date.format(formats.backendDateFormat),
                ])
            }}
            format={formats.frontendDateFormat}
            getPopupContainer={() => document.body}
            {...otherProps}
        />
    )
}

DateRangePicker.propTypes = {
    value: PropTypes.arrayOf(PropTypes.string),
    onChange: PropTypes.func,
    presets: PropTypes.array,
}

export default DateRangePicker;
